module.exports = __webpack_public_path__ + "static/media/siemaforo.65de5ef6.jpg";